import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.375 3a.7.7 0 0 1 .497.207l2.375 2.391a.7.7 0 0 1 0 .986L8.913 12.96a.69.69 0 0 1-.326.186l-3.166.797a.7.7 0 0 1-.85-.848l.791-3.188a.7.7 0 0 1 .183-.324l6.333-6.376A.7.7 0 0 1 12.375 3Zm-5.954 8.451.633.637-.844.212.211-.849Zm1.996.023-1.389-1.398 5.347-5.383 1.388 1.398-5.346 5.383Z"
            clipRule="evenodd"
        />
        <path
            fill="var(--smar--ursa-icons--selectedColor, currentColor)"
            fillRule="evenodd"
            d="M4.545 16.306a.7.7 0 0 1 .7-.7h9.5a.7.7 0 1 1 0 1.4h-9.5a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
